// @core/api/endpoints/task/list_custom_field_definitions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCustomFieldDefinitionsResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List custom fields
 * Returns all custom field definitions for the tenant, optionally filtered by type or field IDs.
 */
export async function ListCustomFieldDefinitions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCustomFieldDefinitionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/custom-fields`;
  const requestOptions = options;
  return client.get<ListCustomFieldDefinitionsResponse>(requestPath, { ...requestOptions, params });
}
